/*
    this component was already existing in the codebase,
    we've made changes into it so we can reuse it on the new search overview page
    after we will finish the migration we can remove the old component
    and move this one to the correct location
*/

import React, { useContext } from "react";

import dayjs from "dayjs";

import { swSettings } from "app/common/services/swSettings";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";
import { MMXAlertWithPlainTooltip } from "app/components/MMXAlertWithPlainTooltip";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { i18nFilter } from "app/filters/i18nFilter";
import { PngDownload } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/Components/PngDownload";
import { searchOverviewContext } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewGraph/SearchOverviewGraphContext";
import CountryService from "app/services/CountryService";
import DurationService from "app/services/DurationService";
import { allTrackers } from "app/services/track/track";
import StyledBoxSubtitle from "pro-features/styled components/StyledBoxSubtitle/src/StyledBoxSubtitle";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import ExcelDownload from "./ExcelDownload/ExcelDownload";
import {
    MMXAlertWrapper,
    SearchOverviewGraphHeaderStyle,
    StyledHeaderTitle,
    UtilitiesContainer,
    UtilitiesContainerWrapper,
} from "./StyledComponents";

export const GraphTabHeader = (props) => {
    const { isMobileWeb, queryParams, params } = props;
    const { duration, webSource, country } = params;
    const { chartRef, selectedMetricTab, category } = useContext(searchOverviewContext);
    const tooltip = isMobileWeb
        ? "analysis.source.search.overview.analysis.mobile.tooltip"
        : "analysis.source.search.overview.analysis.tooltip";
    const durationObject = DurationService.getDurationData(duration);
    const newMMXAlgoStartData = swSettings.current.resources.NewAlgoMMX;
    const isShowMMXAlertBell =
        webSource !== devicesTypes.DESKTOP &&
        durationObject.raw.from.isBefore(dayjs(newMMXAlgoStartData)) &&
        durationObject.raw.to.isAfter(dayjs(newMMXAlgoStartData));

    const subtitleFilters = React.useMemo(
        () => [
            {
                filter: "date",
                value: {
                    from: durationObject.raw.from.valueOf(),
                    to: durationObject.raw.to.valueOf(),
                    useRangeDisplay:
                        duration !== "28d" &&
                        durationObject.raw.from.format("YYYY-MM") !== durationObject.raw.to.format("YYYY-MM"),
                },
            },
            {
                filter: "country",
                countryCode: country,
                value: CountryService.getCountryById(country)?.text,
            },
            {
                filter: "webSource",
                value: webSource,
            },
        ],
        [durationObject, country, webSource, duration],
    );

    const pngTracking = () => {
        allTrackers.dispatchTrackEvent("Download", "submit-ok", `Over Time Graph/${selectedMetricTab.name}/Png`);
    };

    return (
        <SearchOverviewGraphHeaderStyle marginBottom={0}>
            <FlexColumn>
                <StyledHeaderTitle>
                    <BoxTitle tooltip={i18nFilter()(tooltip)}>
                        <I18n>website.analysis.search.overview.search.performance.over.time.title</I18n>
                        {isShowMMXAlertBell ? (
                            <MMXAlertWrapper>
                                <MMXAlertWithPlainTooltip />
                            </MMXAlertWrapper>
                        ) : null}
                    </BoxTitle>
                    <StyledBoxSubtitle>
                        <BoxSubtitle filters={subtitleFilters} />
                    </StyledBoxSubtitle>
                </StyledHeaderTitle>
            </FlexColumn>
            <UtilitiesContainerWrapper>
                <UtilitiesContainer>
                    <PngDownload
                        metricName={selectedMetricTab.name}
                        chartRef={chartRef}
                        tracking={pngTracking}
                    />
                    <ExcelDownload
                        metricName={selectedMetricTab.name}
                        queryParams={queryParams}
                    />
                </UtilitiesContainer>
            </UtilitiesContainerWrapper>
        </SearchOverviewGraphHeaderStyle>
    );
};
